// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__m20wS","footer":"ModalFilter_footer__2Ggzi"};